import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import { useEffect } from 'react';
import TextInput from './Inputs/TextInput';
import SelfInspectInput from './Inputs/SelfInspectInput';
import TextField from '@material-ui/core/TextField';
import SelfInspectBackButton from '../../pages/self-inspect/SelfInspectBackButton';
import SelfInspectButton from './SelfInspectButton';
import SelfInspectQuestionLabel from './SelfInspectQuestionLabel';

// SERVICES

const styles = theme => ({
  //
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },

  topHalf: {
    flex: 1,
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    // border: '1px solid red',
  },
  bottomHalf: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    // border: '1px solid green',
  },

  image: {
    maxHeight: '80%',
    maxWidth: '100%',
  },

  questionLabel: {
    fontSize: '2rem',
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 20,
  },

  answerContainer: {
    fontSize: '1.25rem',
    width: '100%',
    textAlign: 'center',
  },

  actionContainer: {
    //marginTop: 20,
    flexGrow: 0,
    flexBasis: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'center',
    //background: 'orange',
    paddingTop: 5,
    paddingBottom: 5,
  },
});

const YesNoEditCard = withStyles(styles)(
  ({
    // form values
    cardNumber,
    questionId,
    questionImage,
    questionLabel,
    questionLabel2,
    answerValue,
    showInput,
    alwaysEditable,
    inputType = 'text',
    hideActions,
    //
    // functions
    updateAnswer,
    resetAnswer,
    confirmAnswer,
    //
    // other
    isActive,
    classes,
    goBack,
    hideBackButton,
  }) => {
    const [editing, setEditing] = useState(alwaysEditable);

    const handleChange = evt => {
      const value = evt.target.value;

      updateAnswer({
        cardNumber,
        questionId,
        value,
      });
    };

    const handleYes = () => {
      if (!showInput) {
        updateAnswer({
          cardNumber,
          questionId,
          value: true,
        });
      }

      confirmAnswer({
        cardNumber,
        questionId,
        answers: [{ questionId: questionId, answerText: answerValue }],
      });
    };

    const handleNo = () => {
      if (!showInput) {
        updateAnswer({
          cardNumber,
          questionId,
          value: false,
        });

        return confirmAnswer({
          cardNumber,
          questionId,
        });
      }

      if (editing) {
        resetAnswer({
          cardNumber,
          questionId,
        });
      }

      setEditing(!editing);
    };

    useEffect(() => {
      if (!isActive) {
        setEditing(false);
      }
    }, [isActive]);

    return (
      <div className={classes.container}>
        <div className={classes.container}>
          <div className={classes.topHalf}>
            <img className={classes.image} src={questionImage} />
          </div>

          <div className={classes.bottomHalf}>
            {!!questionLabel && (
              <SelfInspectQuestionLabel isHeader style={{ marginBottom: 20 }}>
                {questionLabel}
              </SelfInspectQuestionLabel>
            )}

            {!!questionLabel2 && (
              <SelfInspectQuestionLabel
                isHeader
                style={{
                  marginTop: 20,
                  marginBottom: 20,
                }}
              >
                {questionLabel2}
              </SelfInspectQuestionLabel>
            )}

            {!!questionId && showInput && (
              <div className={classes.answerContainer}>
                <SelfInspectInput
                  //
                  type={inputType}
                  value={answerValue}
                  onChange={handleChange}
                  disabled={alwaysEditable ? false : !editing}
                />
              </div>
            )}
          </div>
        </div>
        <div className={classnames('row-center-center', classes.actionContainer)}>
          {!hideActions && (
            <>
              {!editing && !hideBackButton && <SelfInspectBackButton onClick={goBack} className="mr-20" />}

              <SelfInspectButton
                label={alwaysEditable ? 'Keep going!' : editing ? 'Save and Continue' : 'Yes!'}
                onClick={handleYes}
                className="mr-20"
              />

              {!alwaysEditable && (
                <>
                  <SelfInspectButton
                    //
                    label={editing ? 'Cancel Changes' : 'No'}
                    secondary
                    onClick={handleNo}
                  />
                </>
              )}
            </>
          )}
        </div>
      </div>
    );
  },
);

YesNoEditCard.propTypes = {};

YesNoEditCard.defaultProps = {};

export default YesNoEditCard;
